export default __webpack_public_path__ + "static/media/schweisser.ed1dbe21.jpg";